module.exports = __webpack_public_path__ + "assets/img/Guide03.facd2881.png";